import * as types from '../mutation-types'
import api from '@/api/initiatives'

// initial state
const state = {
    initiatives: [],
    loaded: false,
}

const getters = {
    initiatives: state => state.initiatives,
    initiativesLoaded: state => state.loaded,
}

const actions = {
    getInitiatives({ commit }) {
        commit(types.SET_INITIATIVES_LOADED, false );
        api.getInitiatives((response) => {
            commit(types.SET_INITIATIVES, response._embedded.Initiatives );
            commit(types.SET_INITIATIVES_LOADED, true );
        })
    },
    cleanInitiatives({commit}) {
        commit(types.SET_INITIATIVES_LOADED, false );
        commit(types.SET_INITIATIVES, {} );
    }
}

const mutations = {
    [types.SET_INITIATIVES] (state, solution ) {
        state.agenda = solution
    },
    [types.SET_INITIATIVES_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


